var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );
dependencies["macros/contentful/full-bleed.j2"] = require( "macros/contentful/full-bleed.j2" );
dependencies["category-static-content-slot.j2"] = require( "category-static-content-slot.j2" );
dependencies["contentful/carousel-module.j2"] = require( "contentful/carousel-module.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/macros/category-content-slots.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
env.getTemplate("macros/contentful/render-entry.j2", false, "category/templates/macros/category-content-slots.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntry")) {
var t_4 = t_1.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_4);
env.getTemplate("macros/contentful/full-bleed.j2", false, "category/templates/macros/category-content-slots.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("determineFullBleed")) {
var t_8 = t_5.determineFullBleed;
} else {
cb(new Error("cannot import 'determineFullBleed'")); return;
}
context.setVariable("determineFullBleed", t_8);
var macro_t_9 = runtime.makeMacro(
["entry"], 
[], 
function (l_entry, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
var t_10 = "";t_10 += "\n\n    <div\n        class=\"o-row o-category-content-slot u-margin-bottom--extra-large ";
t_10 += runtime.suppressValue((lineno = 20, colno = 93, runtime.callWrap(t_8, "determineFullBleed", context, [l_entry])), env.opts.autoescape);
t_10 += "\"\n        data-qa-shopping-page-single-module\n        >\n\n        ";
t_10 += "\n        ";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"sys")),"contentType")),"sys")),"id");
frame.set("contentType", t_11, true);
if(frame.topLevel) {
context.setVariable("contentType", t_11);
}
if(frame.topLevel) {
context.addExport("contentType", t_11);
}
t_10 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "contentType") == "singlePageContentModule") {
t_10 += "\n\n            ";
env.getTemplate("category-static-content-slot.j2", false, "category/templates/macros/category-content-slots.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_10 += t_13
t_10 += "\n\n        ";
})});
}
else {
t_10 += "\n\n            ";
t_10 += runtime.suppressValue((lineno = 33, colno = 24, runtime.callWrap(t_4, "renderEntry", context, [l_entry])), env.opts.autoescape);
t_10 += "\n\n        ";
;
}
t_10 += "\n\n    </div>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("displayContentSlot");
context.setVariable("displayContentSlot", macro_t_9);
var macro_t_16 = runtime.makeMacro(
["entry"], 
[], 
function (l_entry, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
var t_17 = "";t_17 += "\n    ";
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"sys")),"contentType")),"sys")),"id");
frame.set("contentType", t_18, true);
if(frame.topLevel) {
context.setVariable("contentType", t_18);
}
if(frame.topLevel) {
context.addExport("contentType", t_18);
}
t_17 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "contentType") == "carouselInlineModule") {
t_17 += "\n        ";
var t_19;
t_19 = "js-inline-carousel";
frame.set("carouselClass", t_19, true);
if(frame.topLevel) {
context.setVariable("carouselClass", t_19);
}
if(frame.topLevel) {
context.addExport("carouselClass", t_19);
}
t_17 += "\n        ";
env.getTemplate("contentful/carousel-module.j2", false, "category/templates/macros/category-content-slots.j2", null, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_20.render(context.getVariables(), frame, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_17 += t_21
t_17 += "\n    ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "contentType") == "staticInlineModule") {
t_17 += "\n        ";
var t_24;
t_24 = "PAGE_INLINE";
frame.set("categoryContentContext", t_24, true);
if(frame.topLevel) {
context.setVariable("categoryContentContext", t_24);
}
if(frame.topLevel) {
context.addExport("categoryContentContext", t_24);
}
t_17 += "\n        ";
env.getTemplate("category-static-content-slot.j2", false, "category/templates/macros/category-content-slots.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_17 += t_26
t_17 += "\n    ";
})});
}
;
}
t_17 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
context.addExport("displayInlineContentSlot");
context.setVariable("displayInlineContentSlot", macro_t_16);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/macros/category-content-slots.j2"] , dependencies)